/** CNPJ mask, format and check-digit validation (shared). */

export const CNPJ_INVALID_MSG = 'CNPJ inválido. Verifique os dígitos informados.';

export function stripCnpj(value: string): string {
  return (value || '').replace(/\D/g, '').slice(0, 14);
}

/** Typing mask: 00.000.000/0000-00 */
export function applyCnpjMask(value: string): string {
  const digits = stripCnpj(value);
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return digits.replace(/(\d{2})(\d+)/, '$1.$2');
  if (digits.length <= 8) return digits.replace(/(\d{2})(\d{3})(\d+)/, '$1.$2.$3');
  if (digits.length <= 12) return digits.replace(/(\d{2})(\d{3})(\d{3})(\d+)/, '$1.$2.$3/$4');
  return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

/** Listing/detail display — always prefer masked form when 14 digits. */
export function formatCnpj(value?: string | null): string {
  const digits = stripCnpj(value || '');
  if (!digits) return '';
  return applyCnpjMask(digits);
}

function calcCheckDigit(base: string, weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < weights.length; i += 1) {
    sum += parseInt(base[i], 10) * weights[i];
  }
  const mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
}

/** Full CNPJ check-digit validation (rejects repeated digits). */
export function isValidCnpj(value?: string | null): boolean {
  const digits = stripCnpj(value || '');
  if (digits.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(digits)) return false;

  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const d1 = calcCheckDigit(digits.slice(0, 12), w1);
  if (d1 !== parseInt(digits[12], 10)) return false;
  const d2 = calcCheckDigit(digits.slice(0, 13), w2);
  return d2 === parseInt(digits[13], 10);
}
